var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubblesCircleDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 266.133,
    height: 322.823,
    viewBox: "0 0 266.133 322.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 242.525,
    height: 182.43,
    rx: 53,
    fill: "#fff",
    opacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376",
    transform: "translate(-1366 -8473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1389.608 8473)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(0 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(0 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(0 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(0 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(0 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(0 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(0 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(23.609 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(23.609 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(23.609 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(23.609 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(23.609 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(23.609 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(23.609 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(47.217 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(47.217 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(47.217 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(47.217 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(47.217 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(47.217 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(47.217 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(70.826 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(70.826 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(70.826 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(70.826 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(70.826 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(70.826 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(70.826 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(94.434 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(94.434 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(94.434 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(94.434 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(94.434 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(94.434 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(94.434 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(118.043 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(118.043 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(118.043 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(118.043 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(118.043 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(118.043 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(118.043 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(141.652 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(141.652 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(141.652 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(141.652 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(141.652 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(141.652 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(141.652 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(165.26 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(165.26 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(165.26 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(165.26 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(165.26 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(165.26 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(165.26 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(188.869)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(188.869 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(188.869 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(188.869 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(188.869 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(188.869 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(188.869 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(188.869 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(212.477)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(212.477 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(212.477 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(212.477 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(212.477 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(212.477 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(212.477 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(212.477 165.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(236.086)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(236.086 23.609)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(236.086 47.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(236.086 70.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(236.086 94.434)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(236.086 118.043)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(236.086 141.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 3.219,
    cy: 3.219,
    r: 3.219,
    transform: "translate(236.086 165.26)",
    fill: "#fff",
    opacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesCircleDots);
export default __webpack_public_path__ + "static/media/bubbles_circle_dots.b1c9e38373890de377bd8523efd565bd.svg";
export { ForwardRef as ReactComponent };